module.exports = __webpack_public_path__ + "img/f2ea962.png";